'use client'

import { useGetProjectId } from '@/app/slugs'
import { queryKeys } from '@/shared/api/react-query'
import { GetProjectGrowthPointsParams } from '@/shared/api/end-points/project'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { GrowthPoint } from '../../lib'
import services from '../services'

const useGetGrowthPoints = (partialParams?: GetProjectGrowthPointsParams) => {
  const projectIdParams = useGetProjectId()
  const params = partialParams || projectIdParams
  const queryKey = [queryKeys((a, m) => a.project.getProjectGrowthPoints(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => services.getGrowthPoints(params),
    refetchOnWindowFocus: false,
  })

  const queryResult = {
    ...query,
    queryKey,
    data: query.data || [],
  }

  return queryResult as unknown as UseQueryResult<GrowthPoint[]>
}

export default useGetGrowthPoints
